module.exports = __webpack_public_path__ + "img/pey_33.33938108.png";